import React from 'react';
import { SubTitle, Description, Image } from '../../components/layouts';
import { buildImageURL, getTrack } from '../../helpers';
import LazyLoad from 'react-lazyload';
import './style.scss';

const CAMERA_LENS_D = buildImageURL('/camera-lens-1.jpg');
const CAMERA_LENS_M = buildImageURL('/camera-lens-m-1.png');

const track = getTrack({ block: 5 });

export function CameraLens1({ mobile = false }) {
  return (
    <div className="page-section section-camera-lens-1 inverted" data-track={track}>
        <div className="txt-wrapper">
          <SubTitle>
            专业影像制造者
          </SubTitle>
          <Description>
            为追求专业光学成像，X60 Pro+达到了蔡司T*镀膜标准，提高可见光通
            <br/>
            过率，降低反射率，有效减少鬼影、杂散光，影像质感大幅提升。
          </Description>
        </div>
        <LazyLoad>
          <Image className="img-wrapper" src={mobile ? CAMERA_LENS_M : CAMERA_LENS_D} />
        </LazyLoad>
    </div>
  );
}
